import { IonContent, IonMenuButton, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import { ReactNode, RefObject } from 'react';
import { useIntl } from 'react-intl';

import styles from '@components/pageTypes/AppPage.module.css';
import { imageUrl } from '@utils/imageUtils';

type Props = {
  children: ReactNode;
  contentRef?: RefObject<HTMLIonContentElement>;
  scrollable?: boolean;
};

const AppPage = ({ children, contentRef }: Props) => {
  const intl = useIntl();

  return (
    <IonPage>
      <IonToolbar className={styles.bar + ' ion-hide-lg-up'}>
        <IonTitle className={styles.logoTitle} slot="start">
          <img
            alt={intl.formatMessage({ id: 'accessibility.altTags.whiteLogo' })}
            className={styles.logoImage}
            src={imageUrl('logoWhite')}
          />
        </IonTitle>
        <IonMenuButton className={styles.toggle} slot="end" />
      </IonToolbar>

      <IonContent ref={contentRef}>{children}</IonContent>
    </IonPage>
  );
};

export default AppPage;
